import useAPI from '@/hooks/useAPI';
import InsuranceVerificationRepository from '@/repositories/InsuranceVerificationRepository';

const useInsuranceVerificationSources = (enabled = true) => {
  const insuranceVerificationRepository = InsuranceVerificationRepository();

  return useAPI({
    queryKey: ['getInsuranceVerificationSources'],
    queryFn: async () => {
      return await insuranceVerificationRepository.getVerificationSources();
    },
    enabled
  });
};

export default useInsuranceVerificationSources;
